import { AnimatePresence } from "motion/react";
import { FC, Suspense } from "react";
import { useRecoilValue } from "recoil";

import {
  ConfirmDataChangedRideContainer,
  ConfirmDialogHolder,
  ConfirmPassengerDeleteContainer,
  ConfirmRideArchiveContainer,
  ConfirmRideCancelContainer,
  ConfirmSoftValidationContainer,
  ErrorBoundary,
  MuiTopProgress,
  ProducePollingContextWrapper,
} from "@ryde/controls";
import { useAiAdvisor, useRtl } from "@ryde/redux";
import {
  settingsDrawerOpenStateAtom,
  useScrollPositionPageReset,
} from "@ryde/shared";

import { DialogsContainer } from "../dialogs";
import { BulkAiAdvisorDrawer, DrawersContainer } from "../drawers";
import { BookingsPollingService, MapColorsService } from "../services";
import { Settings } from "../settings";
import { LayoutMain } from "./layout.main";

export const Layout: FC = () => {
  // THIS AI IS FOR GENERAL APP HELPER
  const { isBulkAIAdvisorDrawerOpen } = useAiAdvisor("unknown");
  const isSettingsDrawerOpen = useRecoilValue(settingsDrawerOpenStateAtom);

  const { direction } = useRtl();

  useScrollPositionPageReset();

  return (
    <ErrorBoundary>
      <Suspense fallback={<MuiTopProgress />}>
        <LayoutMain />
        <div dir={direction} className="modals_container">
          <AnimatePresence>
            {isSettingsDrawerOpen && <Settings />}
            {isBulkAIAdvisorDrawerOpen && <BulkAiAdvisorDrawer />}
          </AnimatePresence>
          <ProducePollingContextWrapper>
            <DrawersContainer />
          </ProducePollingContextWrapper>
          <ConfirmDialogHolder />
          <DialogsContainer />
          <ConfirmPassengerDeleteContainer />
          <ConfirmRideCancelContainer />
          <ConfirmRideArchiveContainer />
          <ConfirmDataChangedRideContainer />
          <ConfirmSoftValidationContainer />
          <MapColorsService />
          <BookingsPollingService />
        </div>
      </Suspense>
    </ErrorBoundary>
  );
};
